import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from '@my-guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
    canActivateChild: [authGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin-report.module').then((m) => m.AdminReportModule),
    canActivateChild: [authGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'broker',
    loadChildren: () =>
      import('./broker/broker-routing.module').then(
        (m) => m.BrokerRoutingModule
      ),
    canActivateChild: [authGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./users/users.module').then((m) => m.UsersModule),
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'p',
    loadChildren: () =>
      import('./public-view/public-view.module').then(
        (m) => m.PublicViewModule
      ),
  },
  { path: '**', pathMatch: 'full', redirectTo: '/' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
